import { put, call, debounce } from 'redux-saga/effects';
import api from 'api';

import dictionary from 'utils/dictionary.json';

import {
  LOADING_ALLEYE_PROVIDERS,
  FETCH_ALLEYE_PROVIDERS,
  FETCH_ALLEYE_PROVIDERS_SUCCESS,
  FETCH_ALLEYE_PROVIDERS_FAILED,
} from './consts';

function* fetchAlleyeProviders({ payload }) {
  try {
    yield put({ type: LOADING_ALLEYE_PROVIDERS });
    const response = yield call(api.fetchAlleyeProviders, payload);
    if (response.error) {
      yield put({ type: FETCH_ALLEYE_PROVIDERS_FAILED, payload: response.error });
    } else {
      yield put({ type: FETCH_ALLEYE_PROVIDERS_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({ type: FETCH_ALLEYE_PROVIDERS_FAILED, payload: dictionary.defaultError });
  }
}
export default function* main() {
  yield debounce(200, FETCH_ALLEYE_PROVIDERS, fetchAlleyeProviders);
}
